import { render, staticRenderFns } from "./CollapsibleList.vue?vue&type=template&id=2dbb917a&scoped=true&"
import script from "./CollapsibleList.vue?vue&type=script&lang=js&"
export * from "./CollapsibleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbb917a",
  null
  
)

export default component.exports